import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { theme } from '@src/common/styles/Theme';
import type { AddPermitTypeFormInputs } from '@src/permitTypesManager/AddPermitTypeFormInputs';
import type { SectionField } from '@src/permitTypesManager/permitTypeSections/PermitTypeSectionCheboxList';
import { PermitTypeSectionCheckboxList } from '@src/permitTypesManager/permitTypeSections/PermitTypeSectionCheboxList';
import {
  IsDualLaneField,
  IsTrunnionAxleField,
  TrailerAxleCountField,
  TrailerDeckHeightField,
  TrailerEmptyWeightField,
  TrailerGroundClearanceField,
  TrailerHeightField,
  TrailerKingPinSetbackLengthField,
  TrailerKingPinSettingLengthField,
  TrailerLengthField,
  TrailerLicensePlateField,
  TrailerLicensePlateStateField,
  TrailerLicensePlateTypeField,
  TrailerMakeField,
  TrailerRegisteredWeightField,
  TrailerTypeField,
  TrailerUnitNumberField,
  TrailerVINField,
  TrailerWheelbaseField,
  TrailerWidthField,
  TrailerYearField,
} from '@src/permitTypesManager/permitTypeSections/TrailerFields';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const TrailerSection = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<AddPermitTypeFormInputs>();
  const informationFields: SectionField[] = [
    {
      field: TrailerUnitNumberField,
      label: t('fields.trailerUnitNumber'),
    },
    {
      field: TrailerMakeField,
      label: t('fields.trailerMake'),
    },
    {
      field: TrailerTypeField,
      label: t('fields.trailerType'),
    },
    {
      field: TrailerVINField,
      label: t('fields.trailerVIN'),
    },
    {
      field: TrailerYearField,
      label: t('fields.trailerYear'),
    },
    {
      field: TrailerAxleCountField,
      label: t('fields.trailerAxleCount'),
    },
    {
      field: IsDualLaneField,
      label: t('fields.isDualLane'),
    },
    {
      field: IsTrunnionAxleField,
      label: t('fields.isTrunnionAxle'),
    },
  ];

  const licensePlateFields: SectionField[] = [
    {
      field: TrailerLicensePlateField,
      label: t('fields.trailerLicensePlate'),
    },
    {
      field: TrailerLicensePlateStateField,
      label: t('fields.trailerLicensePlateState'),
    },
    {
      field: TrailerLicensePlateTypeField,
      label: t('fields.trailerLicensePlateType'),
    },
  ];

  const dimensionFields: SectionField[] = [
    {
      field: TrailerLengthField,
      label: t('fields.trailerLength'),
    },
    {
      field: TrailerWidthField,
      label: t('fields.trailerWidth'),
    },
    {
      field: TrailerHeightField,
      label: t('fields.trailerHeight'),
    },
    {
      field: TrailerDeckHeightField,
      label: t('fields.trailerDeckHeight'),
    },
    {
      field: TrailerGroundClearanceField,
      label: t('fields.trailerGroundClearance'),
    },
    {
      field: TrailerEmptyWeightField,
      label: t('fields.trailerEmptyWeight'),
    },
    {
      field: TrailerRegisteredWeightField,
      label: t('fields.trailerRegisteredWeight'),
    },
    {
      field: TrailerKingPinSetbackLengthField,
      label: t('fields.trailerKingpinSetbackLength'),
    },
    {
      field: TrailerKingPinSettingLengthField,
      label: t('fields.trailerKingpinSettingLength'),
    },
    {
      field: TrailerWheelbaseField,
      label: t('fields.trailerWheelbaseLength'),
    },
  ];
  return (
    <Stack direction="column" gap={theme.spacing['1']}>
      <Typography style={theme.typography.label.large}>
        {t('trailerInformation')}
      </Typography>
      <PermitTypeSectionCheckboxList
        sectionFields={informationFields}
        control={control}
      />
      <Typography style={theme.typography.label.large}>
        {t('trailerLicensePlateSection', { number: '' })}
      </Typography>
      <PermitTypeSectionCheckboxList
        sectionFields={licensePlateFields}
        control={control}
      />
      <Typography style={theme.typography.label.large}>
        {t('trailerDimensionsSection', { number: '' })}
      </Typography>
      <PermitTypeSectionCheckboxList
        sectionFields={dimensionFields}
        control={control}
      />
    </Stack>
  );
};
